import { State } from '../types';
import {
  CHANGE_PARAM_LANGUAGE,
  GET_PARAM_ASSETS_MANIFEST,
  GET_PARAM_BASE_URL,
  GET_PARAM_BRAND,
  GET_PARAM_CHANNEL,
  GET_PARAM_CONTAINER,
  GET_PARAM_DEPOSIT_URL,
  GET_PARAM_LANGUAGE,
  GET_PARAM_LAYOUT_DIMENSIONS,
  GET_PARAM_PROXY_PREFIX,
  GET_PARAM_USER_DATA,
  GET_PARAM_CLIENT_ID,
  GET_PARAM_PLATFORM,
  GET_PARAM_USER_TOKEN,
  GET_PARAM_WITHDRAWAL_URL,
  GET_PARAM_AMS_SEGMENTS,
  GET_PARAM_THEME,
  GET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID,
  SET_PARAM_ASSETS_MANIFEST,
  SET_PARAM_BASE_URL,
  SET_PARAM_BRAND,
  SET_PARAM_CHANNEL,
  SET_PARAM_CONTAINER,
  SET_PARAM_DEPOSIT_URL,
  SET_PARAM_LANGUAGE,
  SET_PARAM_LAYOUT_DIMENSIONS,
  SET_PARAM_PROXY_PREFIX,
  SET_PARAM_USER_DATA,
  SET_PARAM_CLIENT_ID,
  SET_PARAM_PLATFORM,
  SET_PARAM_USER_TOKEN,
  SET_PARAM_WITHDRAWAL_URL,
  SET_PARAM_AMS_SEGMENTS,
  SET_PARAM_THEME,
  SET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID,
  GET_PARAM_OPERATOR_ID,
  SET_PARAM_OPERATOR_ID,
  GET_PARAM_BRAND_HASH,
  SET_PARAM_BRAND_HASH,
  GET_PARAM_APPLICATION_ID,
  SET_PARAM_APPLICATION_ID,
  GET_PARAM_API_KEY,
  SET_PARAM_API_KEY,
} from '../constants';
import { RequestDataIds } from '../constants/ABA';

/**
 * request:data type
 */
export const getParamContainer = () => ({ type: GET_PARAM_CONTAINER });
export const setParamContainer = (payload: State[RequestDataIds.RenderContainer]) => ({
  type: SET_PARAM_CONTAINER,
  payload,
});
export const getParamLanguage = () => ({ type: GET_PARAM_LANGUAGE });
export const setParamLanguage = (payload: State[RequestDataIds.Language]) => ({
  type: SET_PARAM_LANGUAGE,
  payload,
});
export const changeParamLanguage = (payload: unknown) => ({
  type: CHANGE_PARAM_LANGUAGE,
  payload,
});
export const getParamBaseURL = () => ({ type: GET_PARAM_BASE_URL });
export const setParamBaseURL = (payload: State[RequestDataIds.BaseUrl]) => ({
  type: SET_PARAM_BASE_URL,
  payload,
});
export const getParamBrand = () => ({ type: GET_PARAM_BRAND });
export const setParamBrand = (payload: State[RequestDataIds.Brand]) => ({
  type: SET_PARAM_BRAND,
  payload,
});
export const getParamChannel = () => ({ type: GET_PARAM_CHANNEL });
export const setParamChannel = (payload: State[RequestDataIds.Channel]) => ({
  type: SET_PARAM_CHANNEL,
  payload,
});
export const getParamProxyPrefix = () => ({ type: GET_PARAM_PROXY_PREFIX });
export const setParamProxyPrefix = (payload: State[RequestDataIds.ProxyPrefix]) => ({
  type: SET_PARAM_PROXY_PREFIX,
  payload,
});
export const getParamUserToken = () => ({ type: GET_PARAM_USER_TOKEN });
export const setParamUserToken = (payload: State[RequestDataIds.UserToken]) => ({
  type: SET_PARAM_USER_TOKEN,
  payload,
});
export const getParamUserData = () => ({ type: GET_PARAM_USER_DATA });
export const setParamUserData = (payload: State[RequestDataIds.UserData]) => ({
  type: SET_PARAM_USER_DATA,
  payload,
});
export const getParamClientId = () => ({ type: GET_PARAM_CLIENT_ID });
export const setParamClientId = (payload: State[RequestDataIds.ClientId]) => ({
  type: SET_PARAM_CLIENT_ID,
  payload,
});
export const getParamPlatform = () => ({ type: GET_PARAM_PLATFORM });
export const setParamPlatform = (payload: State[RequestDataIds.Platform]) => ({
  type: SET_PARAM_PLATFORM,
  payload,
});
export const getParamDepositUrl = () => ({ type: GET_PARAM_DEPOSIT_URL });
export const setParamDepositUrl = (payload: State[RequestDataIds.DepositUrl]) => ({
  type: SET_PARAM_DEPOSIT_URL,
  payload,
});
export const getParamWithdrawalUrl = () => ({ type: GET_PARAM_WITHDRAWAL_URL });
export const setParamWithdrawalUrl = (payload: State[RequestDataIds.WithdrawalUrl]) => ({
  type: SET_PARAM_WITHDRAWAL_URL,
  payload,
});
export const getParamLayoutDimensions = () => ({
  type: GET_PARAM_LAYOUT_DIMENSIONS,
});
export const setParamLayoutDimensions = (payload: State[RequestDataIds.LayoutDimensions]) => ({
  type: SET_PARAM_LAYOUT_DIMENSIONS,
  payload,
});
export const getParamAssetsManifest = () => ({
  type: GET_PARAM_ASSETS_MANIFEST,
});
export const setParamAssetsManifest = (payload: State[RequestDataIds.AssetsManifest]) => ({
  type: SET_PARAM_ASSETS_MANIFEST,
  payload,
});

export const getParamAMSSegments = () => ({ type: GET_PARAM_AMS_SEGMENTS });
export const setParamAmsSegments = (payload: State[RequestDataIds.AmsSegments]) => ({
  type: SET_PARAM_AMS_SEGMENTS,
  payload,
});

export const getParamTheme = () => ({ type: GET_PARAM_THEME });
export const setParamTheme = (payload: State[RequestDataIds.Theme]) => ({
  type: SET_PARAM_THEME,
  payload,
});

export const getParamCrossDomainClickStreamId = () => ({ type: GET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID });
export const setParamCrossDomainClickStreamId = (payload: State[RequestDataIds.Theme]) => ({
  type: SET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID,
  payload,
});

export const getParamOperatorId = () => ({ type: GET_PARAM_OPERATOR_ID });
export const setParamOperatorId = (payload: State[RequestDataIds.Operator]) => ({
  type: SET_PARAM_OPERATOR_ID,
  payload,
});

export const getParamBrandHash = () => ({ type: GET_PARAM_BRAND_HASH });
export const setParamBrandHash = (payload: State[RequestDataIds.BrandHash]) => ({
  type: SET_PARAM_BRAND_HASH,
  payload,
});

export const getParamApplicationId = () => ({ type: GET_PARAM_APPLICATION_ID });
export const setParamApplicationId = (payload: State[RequestDataIds.ApplicationId]) => ({
  type: SET_PARAM_APPLICATION_ID,
  payload,
});

export const getParamAPIKey = () => ({ type: GET_PARAM_API_KEY });
export const setParamAPIKey = (payload: State[RequestDataIds.APIKey]) => ({
  type: SET_PARAM_API_KEY,
  payload,
});
